import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { RingostatUserSettings, UpsertRingostatUserSettingsDto } from 'src/typings';

@Injectable({
  providedIn: 'root'
})
export class RingostatUserSettingsService {
  constructor(private readonly http: HttpClient) {}

  getMySettings(): Observable<RingostatUserSettings> {
    return this.http.get<RingostatUserSettings>(`${environment.BACKEND}/ringostat/me/settings`);
  }

  saveMySettings(payload: UpsertRingostatUserSettingsDto): Observable<RingostatUserSettings> {
    return this.http.put<RingostatUserSettings>(
      `${environment.BACKEND}/ringostat/me/settings`,
      payload
    );
  }

  getUserSettings(userId: number): Observable<RingostatUserSettings> {
    return this.http.get<RingostatUserSettings>(
      `${environment.BACKEND}/ringostat/users/${userId}/settings`
    );
  }

  saveUserSettings(
    userId: number,
    payload: UpsertRingostatUserSettingsDto
  ): Observable<RingostatUserSettings> {
    return this.http.put<RingostatUserSettings>(
      `${environment.BACKEND}/ringostat/users/${userId}/settings`,
      payload
    );
  }
}
